import React from 'react'
import './Design.css'

const DesignButtons = () => {
    return (
        <div>
        <button className="allbtn"> All </button>
        <button className="webmobbtn"> Web and Mobile UI </button> 
        <button className="brandbtn"> Branding and Logo </button> 
        <button className="printbtn"> Print </button> 
        </div>
    )
    
}

export default DesignButtons